'use client';

import { useAuth } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';

import { getHumanReviewRequest } from '@/lib/admin/client';
import { humanReviewRequestQueryKey } from '@/lib/admin/queryKeys';

export function useHumanReviewRequest(requestId: string | null) {
  const { getToken, isLoaded, isSignedIn, sessionId, userId } = useAuth();
  const ready = isLoaded && !!isSignedIn && !!userId && !!sessionId;

  return useQuery({
    queryKey: humanReviewRequestQueryKey({ userId, sessionId }, requestId),
    enabled: ready && requestId !== null,
    retry: false,
    queryFn: async () => {
      const token = await getToken();
      if (!token) throw new Error('Missing auth token');
      if (!requestId) throw new Error('Missing human-review request');
      return getHumanReviewRequest(token, requestId);
    },
  });
}
